import { globalText, marketplaceText } from "../../../../assets/texts";
import { type DataColumns, type HeaderColumns } from "../../../../types/FilterTable";
import { type EntitlementConfig } from "../hooks/useMarketplaceEntitlements";

export const headerColumns: HeaderColumns<EntitlementConfig> = [
  {
    value: "@",
    style: { align: "left", padding: "normal" },
  },
  {
    label: marketplaceText.BILLING_ACCOUNT_ID,
    value: "accountDoc.data.billingAccountId",
    tooltip: marketplaceText.BILLING_ACCOUNT_ID,
    style: { align: "left", padding: "normal" },
  },
  {
    label: marketplaceText.CUSTOMER,
    value: "customer.data.primaryDomain",
    tooltip: marketplaceText.CUSTOMER,
    style: { align: "left", padding: "normal" },
  },
  {
    label: marketplaceText.ENTITLEMENT_ID,
    value: "ref.id",
    tooltip: marketplaceText.ENTITLEMENT_ID,
    style: { align: "left", padding: "normal" },
    hiddenByDefault: true,
  },
  {
    label: marketplaceText.ACCOUNT_ID,
    value: "transform.procurementAccountId",
    tooltip: marketplaceText.ACCOUNT_ID,
    style: { align: "left", padding: "normal" },
    hiddenByDefault: true,
  },
  {
    label: marketplaceText.PRODUCT,
    value: "transform.product",
    tooltip: marketplaceText.PRODUCT,
    style: { align: "left", padding: "normal" },
  },
  {
    label: marketplaceText.CREATE_TIME,
    value: "data.procurementEntitlement.createTime",
    tooltip: marketplaceText.CREATE_TIME,
    style: { align: "left", padding: "normal" },
  },
  {
    label: marketplaceText.LAST_UPDATE,
    value: "data.procurementEntitlement.updateTime",
    tooltip: marketplaceText.LAST_UPDATE,
    style: { align: "left", padding: "normal" },
  },
  {
    label: marketplaceText.STATE,
    value: "transform.state",
    tooltip: marketplaceText.STATE,
    style: { align: "left", padding: "normal" },
  },
  {
    value: "@",
    style: { align: "left", padding: "normal" },
  },
];

export const filterColumns: DataColumns<EntitlementConfig> = [
  {
    label: marketplaceText.BILLING_ACCOUNT_ID,
    path: "accountDoc.data.billingAccountId",
  },
  {
    label: marketplaceText.CUSTOMER,
    path: "customer.data.primaryDomain",
    comparators: ["==", "!="],
    toOption: (value) => ({
      value,
      label: value ?? globalText.NA,
    }),
  },
  {
    label: marketplaceText.ENTITLEMENT_ID,
    path: "ref.id",
  },
  {
    label: marketplaceText.ACCOUNT_ID,
    path: "transform.procurementAccountId",
  },
  {
    label: marketplaceText.PRODUCT,
    path: "transform.product",
    comparators: ["==", "!="],
  },
  {
    label: marketplaceText.STATE,
    path: "transform.state",
    comparators: ["==", "!="],
  },
  {
    label: marketplaceText.ACCOUNT_ID,
    path: "data.procurementEntitlement.account",
  },
] as const;
